import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../service.css";

export const LuggagePriceList = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className="tj-inner-banner">
        <div className="container">
          <h2>Lugage Policy</h2>
        </div>
      </div>

      <div className="tj-breadcrumb">
        <div className="container">
          <ul className="breadcrumb-list">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li className="active">Lugage Policy</li>
          </ul>
        </div>
      </div>
      <div className="container" style={{ paddingTop: "90px" }}>
        <div style={{ padding: "30px", display: "flex" }}></div>

        <h1 className="farex-h1">Luggage</h1>

        <div id="section-43678" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <p>
              You should add <strong>additional luggage</strong> or{" "}
              <strong>special luggage</strong> to your trip during your booking
              process or online after completed ticket purchase via{" "}
              <Link to={"/booknow"}>
                Manage My Booking
              </Link>
              . Adding luggage at the car is subject to higher fees. Therefore,
              we recommend you to add it online before your trip starts and as
              early as possible, since there is limited space for luggage in the
              vehicle.
            </p>
            <p>
              Availability and luggage fee vary depending on the route, line,
              time of booking and method of booking.&nbsp;
              <br />
              Please find more information and product details in the{" "}
              <Link to={"/luggage-policy"}>Farex luggage policy</Link>  
              .
            </p>
            <h2>
              <br />
              Pricing overview for additional and special luggage
            </h2>
            <table>
              <thead>
                <tr>
                  <th>Currency</th>
                  <th>Code</th>
                  <th>Price range</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Euro</td>
                  <td>EUR</td>
                  <td>4.99 - 18</td>
                </tr>
                <tr>
                  <td>US Dollar</td>
                  <td>USD</td>
                  <td>21.99 - 44.99</td>
                </tr>
                <tr>
                  <td>Swiss Franc</td>
                  <td>CHF</td>
                  <td>6 - 22</td>
                </tr>
                <tr>
                  <td>Czech Crown</td>
                  <td>CZK</td>
                  <td>59 - 180</td>
                </tr>
                <tr>
                  <td>Hungarian Forint</td>
                  <td>HUF</td>
                  <td>600 - 2,400</td>
                </tr>
                <tr>
                  <td>Norwegian Crown</td>
                  <td>NOK</td>
                  <td>49 - 180</td>
                </tr>
                <tr>
                  <td>Swedish Crown</td>
                  <td>SEK</td>
                  <td>49 - 180</td>
                </tr>
                <tr>
                  <td>Bulgarian Lev</td>
                  <td>BGN</td>
                  <td>7.99 - 38</td>
                </tr>
                <tr>
                  <td>Romanian Leu</td>
                  <td>RON</td>
                  <td>49.99 - 180</td>
                </tr>
                <tr>
                  <td>British Pound</td>
                  <td>GBP</td>
                  <td>4.99 - 18</td>
                </tr>
                <tr>
                  <td>Polish Zloty</td>
                  <td>PLN</td>
                  <td>8.99 - 50</td>
                </tr>
                <tr>
                  <td>Danish Crown</td>
                  <td>DKK</td>
                  <td>49 - 180</td>
                </tr>
                <tr>
                  <td>Serbian Dinar</td>
                  <td>RSD</td>
                  <td>199 - 2,100</td>
                </tr>
                <tr>
                  <td>Bosnian &amp; Herzegovinian Konvertible Mark</td>
                  <td>BAM</td>
                  <td>4.90 - 34</td>
                </tr>
                <tr>
                  <td>Albanian Lek</td>
                  <td>ALL</td>
                  <td>249 - 2,400</td>
                </tr>
                <tr>
                  <td>Ukrainian Hrywnja*</td>
                  <td>UAH</td>
                  <td>59 - 320</td>
                </tr>
                <tr>
                  <td>Macedonian Denar</td>
                  <td>MKD</td>
                  <td>119 - 1,100</td>
                </tr>
                <tr>
                  <td>Turkish Lira</td>
                  <td>TRY</td>
                  <td>35 - 144</td>
                </tr>
                <tr>
                  <td>Brazilian Real</td>
                  <td>BRL</td>
                  <td>29.99 - 69.99</td>
                </tr>
                <tr>
                  <td>Canadian Dollar</td>
                  <td>CAD</td>
                  <td>19.99 - 60</td>
                </tr>
                <tr>
                  <td>Chilean Peso</td>
                  <td>CLP</td>
                  <td>2,190 - 6,000</td>
                </tr>
                <tr>
                  <td>Mexican Peso</td>
                  <td>MXN</td>
                  <td>299.99 - 1,200</td>
                </tr>
                <tr>
                  <td>Indian Rupee</td>
                  <td>INR</td>
                  <td>149 - 400</td>
                </tr>
              </tbody>
            </table>
            <p className="fineprint">
              <br />
              <strong>Legend</strong>
            </p>
            <p className="fineprint">
              *Luggage booking after the ticket has been booked is not available
              for Ukrainian lines.
            </p>
            <p>
              <br />
              Please find more information in our{" "}
              <Link to={"/term-condition"}>
                terms &amp; conditions
              </Link>
              . (Farex)
            </p>
       
          </div>
        </div>
      </div>
    </div>
  );
};
